import * as Sentry from '@sentry/react'

import { useEffect } from 'react'
// eslint-disable-next-line no-restricted-imports
import {
  useLocation,
  useNavigationType,
  createRoutesFromChildren,
  matchRoutes,
} from 'react-router'

import Configs from 'infrastructure/config/environment'
const configs = Configs()

if (configs.SentryDSN) {
  Sentry.init({
    dsn: configs.SentryDSN,
    environment: configs.Environment,
    attachStacktrace: true,
    tracesSampleRate: 1.0,
    profilesSampleRate: 1.0,
    replaysSessionSampleRate: 1.0,
    replaysOnErrorSampleRate: 1.0,
    integrations: [
      // automatic instrumentation for web
      Sentry.browserTracingIntegration(),
      // enable custom instrumentation to see deeper into React
      Sentry.reactRouterV6BrowserTracingIntegration({
        useEffect,
        useLocation,
        useNavigationType,
        createRoutesFromChildren,
        matchRoutes,
      }),
      Sentry.replayIntegration(),
    ],
    tracePropagationTargets: [new RegExp(`^${configs.ApiUrl}/`)],
    // Add Sentry CORS to Content Service then add: new RegExp(`^${configs.ContentUrl}/`)
  })
}
